/* eslint-disable jsx-a11y/anchor-is-valid */
import { get, isEmpty, sortBy } from "lodash";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import {
  DocumentTypeIcon,
  Link,
  PayrollCardTop,
  FileTypeWithExt,
  WarningModal,
} from "../../../components";
import { appLayoutStore, deleteUploadedFile } from "../../../contexts";
import { MANAGE_PAYROLL_ROUTES } from "../../../utils";
import { deleteUploadedFileById } from "../../../services";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { faRedo } from "@fortawesome/pro-solid-svg-icons";
import permissions from "../../../mocks/menuPermissions.json";
import authService from "../../../components/api-authorization/AuthorizeService";

const validationReports = [
  "File is invalid format. Additional column['Column1'] found. Please upload the correct template.",
  "Error at the first sheet - Row Number[2] – Column['SSN'] --> 'QWERTY' is invalid. Accepted format is xxxxxxxxx or xxx-xx-xxxx, x being a number'.",
  "Error at the first sheet - Row Number[3] – Column['PAY DATE'] --> Invalid date. Accepted format is mm/dd/yyyy.'",
];

const DataMismatchErrors = ({ data }) => {
  const { state: state2 } = useContext(appLayoutStore);
  const [showmodal, setShowmodal] = useState(false);
  const history = useHistory();
  const handleConfirmClick = () => {
    deleteUploadedFileById(parseInt(data.id))
      .then((response) => {
        history.push({
          pathname: MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD,
        });
        // dispatch(
        //   setManagePayrollToastInfo({
        //     showToast: false,
        //     toastMessage: "File Deleted Successfully",
        //   })
        // )
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
  const handleCancelClick = () => {
    setShowmodal(false);
  };
  var listData = sortBy(data.errorMessages, "rowNumber");
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  return (
    <div className="file-information">
      <div className="d-flex justify-content-between">
        <div className="mt-20 payroll-sub-head">File validation</div>
        {permissions &&
          permissions[roleName]["payrollSubMenu"]?.["reUploadFile"]?.includes(
            "C"
          ) && (
            <Link
              onClick={() => {
                setShowmodal(true);
                // deleteUploadedFile(data.id);
              }}
              style={{ paddingTop: "16px" }}
            >
              {/* <Link to={MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD}> */}
              {/* </Link> */}
              <FontAwesomeIcon icon={faRedo} className="mr-top2" /> &nbsp;
              Reupload
            </Link>
          )}
      </div>
      <div className="border-top" />
      <Row>
        <Col md="9" className="mt-20">
          <div className="d-flex justify-content-between align-baseline">
            <FileTypeWithExt
              fileName={data.fileName}
              uploadedThrough={data.uploadedThrough}
              description={data.description}
            />
            <div className="mr-2 ft-12 grey-text">
              {moment(data.uploadedDate).toString()}
            </div>
            {/* <div className="mr-2 ft-12 grey-text">{data.uploadedTime}</div> */}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="mt-20">
          <div className="d-flex w-75 justify-content-between">
            <div>
              <div className="ft-12 grey-text">File status</div>
              <div className="ft-14 font-weight-500 error-text mt-10">
                Error In file Processor
              </div>
            </div>
          </div>
          <br />
          <div className="ft-12">
            Kindly reupload corrected or other file to process again
          </div>
          <br />
          {/* <div
            onClick={() => {
              deleteUploadedFile(data.id);
            }}
          >
            <Link to={MANAGE_PAYROLL_ROUTES.NEW_PAYROLL_UPLOAD}>
              <Button disabled>Reupload</Button>
            </Link>
          </div> */}
          <div className="plan-sub-heading">Validation Report</div>
          {!isEmpty(data.errorMessages) && (
            <div className="validation-report w-75">
              <div className="plan-sub-heading">
                Data type validation report
              </div>
              {listData.map((report, index) => (
                <div className="ft-12 font-weight-500 text-black my-2">
                  {`${index + 1}. `}
                  {report.rowNumber
                    ? ` In Row Number ${report.rowNumber} : ${report.messageDescCode}`
                    : report.messageDescCode}
                </div>
              ))}
            </div>
          )}
        </Col>
      </Row>
      <WarningModal show={showmodal} onHide={handleCancelClick}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>
            You are attempting to reupload the file. This file will be deleted
            and you will be navigated to the payroll upload page. Do you wish to
            continue?
          </p>
          <Button className="remove-btn mr-4" onClick={handleConfirmClick}>
            Yes
          </Button>
          <Button className="cancel-btn" onClick={handleCancelClick}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default DataMismatchErrors;
